import SpaceGroups from '../components/templates/space-groups';

export const SpaceGroupsContainer = () => {
  return <SpaceGroups />;
};
